const openClass = 'dialog--open';
const closeMs = 200;
export function findDialog(id, context = document) {
    return context.querySelector('.dialog#dialog-' + CSS.escape(id));
}
function findTrigger(id, context = document) {
    return context.querySelector('[aria-controls="dialog-' + CSS.escape(id) + '"]');
}
function focusables(dialog) {
    return [...dialog.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])')].filter(el => el.offsetParent !== null);
}
function trapTab(dialog, event) {
    if (event.key !== 'Tab')
        return;
    const items = focusables(dialog);
    if (!items.length)
        return;
    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;
    if (event.shiftKey && (active === first || !dialog.contains(active))) {
        event.preventDefault();
        last.focus();
    }
    else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
        event.preventDefault();
        first.focus();
    }
}
export function openDialog(id, context = document) {
    var _a;
    const dialog = findDialog(id, context);
    if (!dialog)
        return false;
    dialog.classList.add(openClass);
    ((_a = focusables(dialog)[0]) !== null && _a !== void 0 ? _a : dialog).focus();
    return true;
}
export function closeDialog(dialog) {
    dialog.classList.remove(openClass);
    const id = dialog.id.replace(/^dialog-/, '');
    const trigger = findTrigger(id);
    if (trigger)
        trigger.focus();
}
export function closeAllDialogs(context = document) {
    return closeIn(context).length > 0;
}
function closeIn(context) {
    const closing = [...context.querySelectorAll('.' + openClass)];
    closing.forEach(el => closeDialog(el));
    return closing;
}
export function swapDialog(id, context = document) {
    if (!findDialog(id, context))
        return false;
    const closing = closeIn(context);
    if (!closing.length) {
        openDialog(id, context);
        return true;
    }
    setTimeout(() => openDialog(id, context), closeMs);
    return true;
}
export function toggleDialog(id, context = document) {
    const dialog = findDialog(id, context);
    if (!dialog)
        return false;
    if (dialog.classList.contains(openClass)) {
        closeDialog(dialog);
        return true;
    }
    return swapDialog(id, context);
}
export function bindDialogs(root = document, context) {
    const scope = context !== null && context !== void 0 ? context : root;
    root.querySelectorAll('[aria-controls^="dialog-"]').forEach(trigger => {
        var _a;
        const id = (_a = trigger.getAttribute('aria-controls')) === null || _a === void 0 ? void 0 : _a.replace(/^dialog-/, '');
        if (!id || !findDialog(id, scope))
            return;
        trigger.addEventListener('click', event => {
            toggleDialog(id, scope);
            event.stopPropagation();
        });
    });
}
export default function dialogs() {
    document.addEventListener('click', event => {
        const target = event.target;
        const dialog = target.closest('.dialog');
        if (target.closest('.dialog__close')) {
            if (dialog)
                closeDialog(dialog);
            return;
        }
        if (!dialog)
            closeAllDialogs();
    });
    document.addEventListener('keydown', event => {
        const open = [...document.querySelectorAll('.' + openClass)];
        const top = open[open.length - 1];
        if (!top)
            return;
        if (event.key === 'Escape') {
            closeDialog(top);
            return;
        }
        trapTab(top, event);
    });
}
